<div class="card" id="card-config">
  <div class="head">
    <h1>Shapes</h1>

    <div class="row">
      <div class="col-md-4">
        <app-select-busca-cliente [clientes]="clientesFormatados" [matlabelOpcional]="'Selecione a usina:'"
          [valorSelecionado]="clientesId" [desabilitado]="false" (clienteSelecionado)="onClienteSelecionado($event)">
        </app-select-busca-cliente>
      </div>

      <div class="col-md-4">
        <label class="label-outside">Pesquisar:</label>
        <div class="input-wrapper">
          <input id="searchbar" matInput name="search" class="form-control input-pesquisa w-75" type="search"
            placeholder="Digite para pesquisar..." (keyup)="applyFilter($event)">
        </div>
      </div>

      <div class="col-md-4 botao-cadastro">
        <div class="">
          <button *ngIf="verificarPermissao(['alteracoes_shapes'])" routerLink="../shapes/cadastro" class="btn-nav">
            <mat-icon class="material-icons-sharp">
              archive
            </mat-icon>
            Novo Shape
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="shape-resumo" *ngIf="!load && ultimoShape">

    <div class="shape-card">

      <div class="shape-header">
        <mat-icon class="shape-icon">description</mat-icon>
        <h3>Último Shape Cadastrado</h3>
      </div>

      <div class="shape-info-grid">

        <div class="shape-info-item">
          <span class="info-label">Arquivo:</span>
          <span class="info-value">
            {{ ultimoShape.vc_nome_original }}
          </span>
        </div>

        <div class="shape-info-item">
          <span class="info-label">Atualizado em:</span>
          <span class="info-value">
            {{ ultimoShape.ts_atualizado_em | date:'dd/MM/yyyy HH:mm:ss' }}
          </span>
        </div>

        <div class="shape-info-item">
          <span class="info-label">Status:</span>

          <span class="status-badge" [ngClass]="{
            'status-processado': ultimoShape.vc_status === 'PROCESSADO',
            'status-pendente': ultimoShape.vc_status !== 'PROCESSADO'
          }">
            {{ ultimoShape.vc_status }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive overflow">
    <table mat-table [dataSource]="dataSource" class="table" multiTemplateDataRows>
      <ng-container matColumnDef="fazenda">
        <th mat-header-cell *matHeaderCellDef class="fazenda">Fazenda</th>
        <td mat-cell *matCellDef="let shape" class="fazenda">
          <span *ngIf="shape">
            {{shape.vc_nome}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="area_total">
        <th mat-header-cell *matHeaderCellDef>Área Total (ha)</th>
        <td mat-cell *matCellDef="let shape">
          <span *ngIf="shape">
            {{shape.area_total}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="quantidade_talhoes">
        <th mat-header-cell *matHeaderCellDef>Quantidade de Talhões</th>
        <td mat-cell *matCellDef="let shape">
          <span *ngIf="shape">
            {{shape.quantidade_talhoes}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ultimaAtualizacao">
        <th mat-header-cell *matHeaderCellDef>Última Atualização</th>
        <td mat-cell *matCellDef="let shape">
          <span *ngIf="shape">
            {{shape.shape?.ts_atualizado_em | date: "dd/MM/yyyy HH:mm:ss"}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="acaoMapa">
        <th mat-header-cell *matHeaderCellDef class="text-center">Visualizar mapa</th>
        <td mat-cell *matCellDef="let shape" class="text-center">
          <button class="btn-nav" title="Visualizar no Mapa" (click)="visualizarMapa(shape)">
            <mat-icon class="material-icons-sharp mapa">map</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandir">
        <th mat-header-cell *matHeaderCellDef class="text-center">Detalhes</th>
        <td mat-cell *matCellDef="let shape" class="text-center">
          <button mat-icon-button (click)="expandedElement = expandedElement === shape ? null : shape" title="Expandir">
            <mat-icon>
              {{ expandedElement === shape ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let shape" [attr.colspan]="columnsToDisplay.length">
          <div class="expanded-detail" [@detailExpand]="shape == expandedElement ? 'expanded' : 'collapsed'">
            <div class="expanded-content">
              <h3 class="talhoes-title">Talhões da {{shape.vc_nome}}</h3>
              <div class="talhoes-grid">
                <div class="talhao-card" *ngFor="let talhao of shape.talhoes">
                  <div class="talhao-content">
                    <div class="talhao-header">
                      <img src="assets/icone-poligono.png" class="talhao-icon" />
                      <h4>{{talhao.vc_nome}}</h4>
                    </div>

                    <div class="talhao-info">
                      <div class="info-item">
                        <span class="info-label">Área:</span>
                        <span class="info-value">
                          {{talhao.fl_area | number:'1.2-2'}} ha
                        </span>
                      </div>

                      <div class="info-item" *ngIf="talhao.bloco">
                        <span class="info-label">Bloco:</span>
                        <span class="info-value">{{talhao.bloco}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="talhao-footer">
                    Atualizado em
                    {{talhao.ts_atualizado_em | date:'dd/MM/yyyy HH:mm:ss'}}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" class="element-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    </table>
    <div class="load" *ngIf="load">
      <mat-progress-spinner diameter="30" mode="indeterminate">
      </mat-progress-spinner>
    </div>
    <div class="mensagem" *ngIf="validaResp && !load">
      <p class="text-center">
        Cliente selecionado não possui fazendas
      </p>
    </div>
  </div>
</div>